import { render, staticRenderFns } from "./mail_revise.vue?vue&type=template&id=a17e8ff0&scoped=true&"
import script from "./mail_revise.vue?vue&type=script&lang=js&"
export * from "./mail_revise.vue?vue&type=script&lang=js&"
import style0 from "./mail_revise.vue?vue&type=style&index=0&id=a17e8ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e8ff0",
  null
  
)

export default component.exports